import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useRef, useEffect } from 'react';
import { X } from 'lucide-react';
export const ColumnNameEditor = ({ columnId, currentName, isOpen, onClose, onSave, }) => {
    const [name, setName] = useState(currentName);
    const inputRef = useRef(null);
    useEffect(() => {
        setName(currentName);
    }, [currentName]);
    useEffect(() => {
        if (isOpen && inputRef.current) {
            inputRef.current.focus();
            inputRef.current.select();
        }
    }, [isOpen]);
    const handleSave = () => {
        if (name.trim() && name !== currentName) {
            onSave(columnId, name.trim());
        }
        onClose();
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSave();
        }
        else if (e.key === 'Escape') {
            setName(currentName);
            onClose();
        }
    };
    if (!isOpen)
        return null;
    return (_jsx("div", { className: "fixed inset-0 bg-black/50 flex items-center justify-center z-50", onClick: onClose, children: _jsxs("div", { className: "bg-gray-800 rounded-lg p-6 w-full max-w-md", onClick: (e) => e.stopPropagation(), children: [_jsxs("div", { className: "flex items-center justify-between mb-4", children: [_jsx("h2", { className: "text-lg font-semibold text-white", children: "Rename Column" }), _jsx("button", { onClick: onClose, className: "text-gray-400 hover:text-white", children: _jsx(X, { className: "w-5 h-5" }) })] }), _jsxs("div", { className: "mb-6", children: [_jsx("label", { className: "block text-sm font-medium text-gray-300 mb-2", children: "Column Name" }), _jsx("input", { ref: inputRef, type: "text", value: name, onChange: (e) => setName(e.target.value), onKeyDown: handleKeyDown, placeholder: "Enter column name", className: "w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white text-sm placeholder-gray-400 focus:outline-none focus:border-blue-400" })] }), _jsxs("div", { className: "flex gap-2", children: [_jsx("button", { onClick: handleSave, disabled: !name.trim() || name === currentName, className: "flex-1 px-4 py-2 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-600 disabled:cursor-not-allowed text-white rounded-lg transition-colors", children: "Save" }), _jsx("button", { onClick: onClose, className: "flex-1 px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors", children: "Cancel" })] })] }) }));
};
